import jsonPKG from '../../package.json';
import { env } from '../server/server';

export const version = env.includes('wework') ? '' : `v ${jsonPKG.version}`;
export const v = jsonPKG.version;
